import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { ShippingAddressesProps } from "../interfaces";
import './shippingAddresses.scss';

const ShippingAddresses: React.FC<ShippingAddressesProps> = ({
    initialAddressLine1,
    initialAddressLine2,
    onUpdate,
    updateButtonClicked
}) => {
    const [addressLine1, setAddressLine1] = useState(initialAddressLine1);
    const [addressLine2, setAddressLine2] = useState(initialAddressLine2);
    const [isAddressLine1Touched, setIsAddressLine1Touched] = useState(false);
    const [errors, setError] = useState<{ addressLine1: boolean }>({
        addressLine1: false,
    });

    const [prevUpdateClicked, setPrevUpdateClicked] = useState(false);

    useEffect(() => {
        setAddressLine1(initialAddressLine1);
        setAddressLine2(initialAddressLine2);
    }, [initialAddressLine1, initialAddressLine2]);

    useEffect(() => {
        const hasAddressLine1Error = isAddressLine1Touched && !addressLine1.trim();
        setError({
            addressLine1: hasAddressLine1Error,
        });
    }, [addressLine1, isAddressLine1Touched]);

    useEffect(() => {
        if (updateButtonClicked && !prevUpdateClicked) {
            const hasAddressLine1Error = !addressLine1.trim();
            setError({
                addressLine1: hasAddressLine1Error,
            });

            if (!hasAddressLine1Error) {
                onUpdate({ addressLine1, addressLine2 });
            }

            setPrevUpdateClicked(true);
        } else if (!updateButtonClicked) {
            setPrevUpdateClicked(false);
        }
    }, [updateButtonClicked, prevUpdateClicked, addressLine1, addressLine2, onUpdate]);

    const handleAddressLine2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAddressLine2(value);
        onUpdate({ addressLine1, addressLine2: value });
    };

    const handleAddressLine1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAddressLine1(value);
        setIsAddressLine1Touched(true);
        onUpdate({ addressLine1: value, addressLine2 });
    };

    return (
        <div className="address-fields">
            <div className="input-container">
                <label htmlFor="addressLine1" className="input-label">Address Line 1</label>
                <Input
                    id="addressLine1"
                    name="addressLine1"
                    autoComplete="off"
                    value={addressLine1}
                    onChange={handleAddressLine1Change}
                    status={errors.addressLine1 ? 'error' : undefined}
                />
            </div>
            <div className="input-container">
                <label htmlFor="addressLine2" className="input-label-second">Address Line 2</label>
                <Input
                    id="addressLine2"
                    name="addressLine2"
                    autoComplete="off"
                    value={addressLine2}
                    onChange={handleAddressLine2Change}
                />
            </div>
        </div>
    );
};

export default ShippingAddresses;
